module.exports = __webpack_public_path__ + "img/mlc - smart ready.0721d6cd.png";